import type { RenderPlaceholderProps } from 'slate-react';

import style from './placeholder.module.scss';

export const Placeholder = ({ attributes, children }: RenderPlaceholderProps) => (
  <span
    {...attributes}
    style={{
      ...attributes.style,
      opacity: 1,
    }}
    className={style.Placeholder}
  >
    {children}
  </span>
);
